module.exports = __webpack_public_path__ + "img/7.95af4a33.png";